import { CommonModule } from '@angular/common';
import { Component, HostListener, Input } from '@angular/core';
import { OverlayColor } from '@app/core/enum/loader.enum';
import { GeneralConstants } from '@constants/generalConstants';

@Component({
  selector: 'aladdin-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  @Input() isLoading?: boolean;
  @Input() isBlockLineLoader?: boolean;
  @Input() title?: string = GeneralConstants.LOADING;
  @Input() fullScreen?: boolean;
  @Input() overlay: OverlayColor = OverlayColor.WHITE;

  balls = [1, 2, 3, 4];

  @HostListener('wheel', ['$event'])
  handleWheelEvent(event: WheelEvent) {
    if (this.fullScreen) {
      event.preventDefault();
    }
  }
}
